"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectDebitProposalWidget = void 0;
var React = require("react");
var reactstrap_1 = require("reactstrap");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var DirectDebitProposalWidget = exports.DirectDebitProposalWidget = /** @class */ (function (_super) {
    __extends(DirectDebitProposalWidget, _super);
    function DirectDebitProposalWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.updateAutomaticRenewal = function () {
            if (_this.state.changeToDirectDebit === true) {
                _this.executeEvent("change");
            }
            else {
                _this.executeEvent("click");
            }
        };
        _this.hideModal = function () {
            _this.executeEvent("blur");
        };
        _this.changeToDirectDebit = function (event) {
            var value = event.target.value === "true";
            _this.setState({
                changeToDirectDebit: value
            });
        };
        _this.state = {
            renewalProposal: undefined,
            isOpen: true,
            changeToDirectDebit: undefined,
            showSuccessModal: false,
        };
        return _this;
    }
    DirectDebitProposalWidget.prototype.componentDidMount = function () {
        var _this = this;
        this.customerPortalService.getRenewalProposal(this.props.interaction.agreementNumber).subscribe(function (renewalProposal) {
            _this.setState({
                renewalProposal: renewalProposal,
            });
        });
    };
    DirectDebitProposalWidget.prototype.render = function () {
        return (React.createElement(React.Fragment, null, React.createElement(reactstrap_1.Modal, { className: "my-2 manual-renewal-modal", isOpen: this.state.isOpen, toggle: this.hideModal },
            React.createElement(reactstrap_1.ModalHeader, { close: React.createElement("button", { className: "btn-close", onClick: this.hideModal }) }),
            React.createElement(reactstrap_1.ModalBody, { className: "pt-0" },
                React.createElement("h1", { className: "a-bold fs-20" }, "You can now pay by monthly Direct Debit"),
                React.createElement("div", null,
                    React.createElement("p", { className: "mb-2 pt-4" },
                        React.createElement("span", { className: "font-weight-light" }, "You currently pay by monthly card payment, which can sometimes lead to missed payments, for example if your card expires or needs replacing."))),
                React.createElement("div", null,
                    React.createElement("p", { className: "mb-2 pt-4" },
                        React.createElement("span", { className: "font-weight-light" },
                            React.createElement("b", null, "Why do people choose Direct Debit?"),
                            " Many customers prefer Direct Debit as it uses your bank details, not your card details. They rarely need updating and the Direct Debit Guarantee ensures you get a refund if an error\u2019s made in the payment."))),
                React.createElement("div", null,
                    React.createElement("p", { className: "mb-2 pt-4" },
                        React.createElement("span", { className: "font-weight-light" }, "It\u2019s quick and easy, we just need your bank account number and sort code."))),
                React.createElement("h2", { className: "padding-bottom-16 font-weight-semi-bold pt-4" }, "How would you like to pay for your car policy?"),
                React.createElement("div", { className: "input-group" },
                    React.createElement("div", { className: "custom-control w-100" },
                        React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: "continue-monthly-card-payment", id: "continue-monthly-card-payment", value: "false", checked: this.state.changeToDirectDebit === false, onChange: this.changeToDirectDebit }),
                        React.createElement("label", { id: "continue-monthly-card-payment-label", className: "checkbox-label label-bg-transparent font-weight-semi-bold", htmlFor: "continue-monthly-card-payment" }, "Stay on monthly card payment")),
                    React.createElement("div", { className: "custom-control w-100" },
                        React.createElement("input", { className: "custom-radiobutton cursor-pointer", type: "radio", name: "change-to-monthly-direct-debit", id: "change-to-monthly-direct-debit", value: "true", checked: this.state.changeToDirectDebit === true, onChange: this.changeToDirectDebit }),
                        React.createElement("label", { id: "driver-label", className: "checkbox-label label-bg-transparent font-weight-semi-bold", htmlFor: "change-to-monthly-direct-debit" }, "Change to monthly direct debit")))),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement("div", { className: "d-flex flex-column w-100" },
                    React.createElement("button", { type: "button", className: "btn btn-primary btn-blue-dashboard m-auto", onClick: this.updateAutomaticRenewal, id: "updateAutomaticRenewal", disabled: this.state.changeToDirectDebit === undefined }, this.state.changeToDirectDebit === false ? "Save changes" : "Continue"),
                    React.createElement("button", { type: "button", className: "btn btn-white-dashboard", onClick: this.hideModal, id: "cancelChanges" }, "Cancel changes"))))));
    };
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.CustomerPortalService),
        __metadata("design:type", Object)
    ], DirectDebitProposalWidget.prototype, "customerPortalService", void 0);
    return DirectDebitProposalWidget;
}(plugin_journey_1.WidgetBase));
//# sourceMappingURL=DirectDebitProposalWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/DirectDebitProposalWidget.js
// module id = 3238
// module chunks = 0